(function () {
  const productMain = document.querySelector('product-main');
  let onceFlag = false;
  if (!productMain) return;

  const observer = new MutationObserver(() => {
    try {
      const upsellBlock = productMain.querySelector(
        'essential-upsell-product-addon-app-block'
      );
      if (!upsellBlock) return;

      //call only once when the block is added to the dom and has the container element inside it
      if (!onceFlag && upsellBlock.querySelector('[data-essential-upsell-element="container"]')) {
        onceFunction();
        onceFlag = true;
      }

      if (upsellBlock.dataset.discountProcessed) return;

      const rawData = upsellBlock.getAttribute('upsell-app-data');
      if (!rawData) return;

      const parsedData = JSON.parse(rawData);

      const activeFunnelId = upsellBlock
        .querySelector('[data-essential-upsell-element="container"]')
        ?.dataset?.essentialUpsellFunnelId;

      const activeFunnel = activeFunnelId
        ? parsedData?.funnels?.find((f) => f.id === activeFunnelId)
        : parsedData?.funnels?.[0];

      const discountValue = activeFunnel?.upsell?.discountValue;
      if (!discountValue) return;

      const title = upsellBlock.querySelector(
        '[data-essential-upsell-element="header"] > [data-essential-upsell-element="title"]'
      );
      if (!title) return;

      const discountSpan = document.createElement('span');
      discountSpan.className = 'discount-off';
      discountSpan.textContent = `${discountValue}% OFF`;
      title.appendChild(discountSpan);

      upsellBlock.dataset.discountProcessed = 'true';
      observer.disconnect();
    } catch (error) {
      console.error('Upsell discount error:', error);
    }
  });

  observer.observe(productMain, {
    childList: true,
    subtree: true,
  });

  function onceFunction() {
    updateCartDiscount();
  }

  /* =======================================
  Money Formatter
  ======================================= */
  function formatMoney(amount) {
    const upsellBlock = productMain.querySelector('essential-upsell-product-addon-app-block');
    const moneyFormat = upsellBlock?.getAttribute('shop-money-format') || '${{amount}}';
    return moneyFormat.replace(/\{\{amount\}\}/, amount.toFixed(2));
  }

/* =======================================
  Cart Discount Update
  ======================================= */
  function updateCartDiscount() {
    const container = document.querySelector('[data-essential-upsell-element="container"]');
    if (!container) return;

    // ── Main ATC button ──────────────────────────────────────────────────────
    const productPrice = productMain.querySelector('product-buttons product-price');
    if (!productPrice) return;

    const finalEl = productPrice.querySelector('.final');
    const compareEl = productPrice.querySelector('.compare');
    if (!finalEl) return;

    // ── Sticky panel ─────────────────────────────────────────────────────────
    const stickyPanel = productMain.querySelector('product-sticky-panel');
    const stickyBtnContent = stickyPanel?.querySelector('.btn_content > span');
    const stickyPriceTextNode = stickyBtnContent ? getStickyPriceTextNode(stickyBtnContent) : null;
    const stickyCompareEl = stickyPanel?.querySelector('product-price .compare');

    const baseFinal = parseFloat(finalEl.textContent.replace(/[^0-9.]/g, ''));
    const rawCompare = parseFloat(compareEl?.textContent.replace(/[^0-9.]/g, '')) || 0;
    const baseCompare = rawCompare > baseFinal ? rawCompare : baseFinal;

    let currentFinal = baseFinal;
    let currentCompare = baseCompare;

    container.addEventListener('change', (event) => {
      const target = event.target;
      if (!target.matches('input[type="checkbox"]')) return;

      const product = target.closest('[data-essential-upsell-element="product"]');
      if (!product) return;

      const discountedPriceEl = product.querySelector('[data-essential-upsell-element="discounted-price"]');
      const regularPriceEl = product.querySelector('[data-essential-upsell-element="regular-price"]');

      const discountedPrice = parseFloat(discountedPriceEl?.dataset.discountedPriceValue || 0);
      const regularPrice = discountedPriceEl
        ? parseFloat(regularPriceEl?.dataset.regularPriceValue || 0)
        : 0;
      const finalPrice = discountedPrice || parseFloat(regularPriceEl?.dataset.regularPriceValue || 0);

      if (target.checked) {
        currentFinal += finalPrice;
        currentCompare += regularPrice != 0 ? regularPrice : finalPrice;
      } else {
        currentFinal -= finalPrice;
        currentCompare -= regularPrice != 0 ? regularPrice : finalPrice;
      }

      updateATCPrice(finalEl, compareEl, stickyPriceTextNode, stickyCompareEl, currentFinal, currentCompare, baseCompare);
    });
  }

  /* =======================================
  Get Sticky Price Text Node
  ======================================= */
  function getStickyPriceTextNode(stickyBtnContent) {
    for (const node of stickyBtnContent.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('$')) {
        return node;
      }
    }
    return null;
  }

  /* =======================================
  Update ATC Button Price
  ======================================= */
  function updateATCPrice(finalEl, compareEl, stickyPriceTextNode, stickyCompareEl, currentFinal, currentCompare, baseCompare) {
    const formattedFinal = formatMoney(currentFinal);
    const formattedCompare = formatMoney(currentCompare);

    // ── Main button ──────────────────────────────────────────────────────────
    finalEl.textContent = formattedFinal;
    if (compareEl) {
      if (currentCompare > currentFinal) {
        compareEl.textContent = formattedCompare;
        compareEl.classList.remove('hide');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hide');
      }
    }

    // ── Sticky panel ─────────────────────────────────────────────────────────
    if (stickyPriceTextNode) {
      stickyPriceTextNode.textContent = stickyPriceTextNode.textContent.replace(/\$[\d,.]+/, formattedFinal);
    }
    if (stickyCompareEl) {
      if (currentCompare > currentFinal) {
        stickyCompareEl.textContent = formattedCompare;
        stickyCompareEl.classList.remove('hide');
      } else {
        stickyCompareEl.textContent = '';
        stickyCompareEl.classList.add('hide');
      }
    }
  }
})();
